<template lang="pug">
  #editCate.container(ref='editCate')
    .row.justify-content-center
      .col-md-6.col-12
        .card
          .card-body
            div
              .col-md-12(style="text-align: left;font: Regular 17px/20px Helvetica;letter-spacing: 0px;color: #343A40;opacity: 1; border-bottom: 1px solid; padding-bottom: 10px;font-weight: bold;padding-top: 10px;") SỬA DANH MỤC BÀI HỌC
            //- .alert.alert-danger(v-if="error") {{error}}
            form(action="#", autocomplete="off")
              .form-group.col-md-12#alert_id(style="margin:0" hidden)
                .alert.alert-danger(v-if="error" style="margin:0") {{error}}
              .form-group(:class='errorArray')
                .col-md-12
                  label.control-label.text-md-right(for="title" style="text-align: left;font: Regular 15px/22px Proxima Nova;letter-spacing: 0px;color: #333333;opacity: 1; margin-bottom: 10px") Tên danh mục
                  input#title.form-control(name="title",required=true,autofocus,placeholder="Nhập",v-model="name")
              .form-group
                .col-md-12.offset-md-12(style="justify-content: center;display: flex;")
                  button.btn.btn-primary(@click.prevent='submitForm' style="background: #FFD311 0% 0% no-repeat padding-box;border-radius: 5px;opacity: 1;width: 160px;color: #23180A; margin-right: 10px") Lưu thay đổi
                  button.btn.btn-primary(@click.prevent="$emit('close')" style="background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #FFD311;border-radius: 5px;opacity: 1;width: 160px;color: #23180A;") Hủy yêu cầu
</template>

<script>
// import firebase from 'firebase'
import $ from 'jquery'

export default {
  name: 'cate-form',
  props: {
    id: Number,
    icon: String,
    title: String,
    description: String,
    saveFunction: Function
  },
  data() {
    return {
      error: null,
      errorArray: [],
      name: this.title
    }
  },
  methods: {
    submitForm() {
      if (this.name !== undefined && this.name !== '') {
        // console.log('Submit Form')
        this.saveFunction({ id: this.id, title: this.name })
        this.$nextTick(() => {
          this.$emit('close')
        })
      } else {
        $('#alert_id').show()
        this.error = 'Tên danh mục là bắt buộc'
        this.errorArray = ['is-empty has-error']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// cateFormEdit.vue?5e246e73